<template>
  <div class="my-2 relative justify-center">
    <input
      :id="id"
      class="input text-sm border-2
        appearance-none flex-auto
        min-w-0 w-full h-12 px-3 py-3 pt-5 pb-2
        focus focus:outline-none
        active:outline-none active:border-blue-900
        disabled:text-gray-400 "
      :class="{
        'border-gray-400' : !error,
        'border-red-600' : error,
        'focus:border-red-600' : error,
        'filled' : modelValue
      }"
      :style="{
        '--focus-border-color': !error ? global.primaryColor : '#002d72'
      }"
      :type="type"
      :name="name"
      :value="modelValue"
      :autofocus="autofocus"
      :autocomplete="autocomplete"
      :disabled="$attrs.disabled"
      :aria-label="$attrs['aria-label']"
      :aria-invalid="$attrs['aria-invalid']"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('update:modelValue', $event.target.value)"
    >
    <label
      v-if="$attrs.disabled"
      class="absolute mb-0 -mt-2 pt-3 pl-3 leading-tighter
         text-gray-700 cursor-text align-middle label-disabled"
      :for="name"
      @click="onLabelClick"
    >{{ placeholder }}</label>
    <label
      v-else
      class="label absolute mb-0 -mt-2 pt-3 pl-3 leading-tighter
         text-gray-700 cursor-text align-middle text-sm filled"
      :for="name"
      @click="onLabelClick"
    >{{ placeholder }}</label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Input',
  props: {
    modelValue: {
      type: String
    },
    id: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '',
      required: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  methods: {
    onLabelClick (label: any) {
      label.srcElement.previousElementSibling.focus();
    }
  }
});
</script>
<style>
.input:focus + .label,
.input:active + .label,
.input.filled + .label {
  font-size: 0.65rem;
  transition: all 0.2s ease-out;
  top: -0.1rem;
  color: #7b808c;
}

.input {
  border-radius: 5px;
}

.input:focus {
  border-color: var(--focus-border-color) !important;
}

.label {
  transition: all 0.2s ease-out;
  top: 0.6rem;
  left: 0;
}

.label-disabled {
  font-size: 0.65rem;
  top: 0.1rem;
  left: 0;
}
</style>
